/**
 * 收件箱发件箱
 * @type {{}}
 */
const initState = {
  unreadCount: 0,
};

const mutations = {
  updateUnreadCount(state, payload) {
    state.unreadCount = payload;
  },
  minusUnreadCount(state) {
    let count = state.unreadCount - 1;
    count = count >= 0 ? count : 0;
    state.unreadCount = count;
  }
};

export default {
  namespaced: true,
  mutations,
  state: initState
};
